module.exports = __webpack_public_path__ + "static/media/ic-task-management.82e1b5ee.svg";